import React, { useCallback, useRef, useState } from 'react';
import { Box, Tooltip } from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import AppLauncherButton from './AppLauncherButton';
import AppLauncherPanel from './AppLauncherPanel';

const AppLauncher = ({
  ids,
  streamPlayerUnlocked,
  favoriteApps,
  favoriteIdSet,
  isFull,
  reorder,
  addToFavorite,
  removeFromFavorite,
}) => {
  const { pathname } = useLocation();
  const focusLoungeNav = pathname === '/focuslounge';
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const navigate = useNavigate();

  const close = useCallback(() => {
    setOpen(false);
    requestAnimationFrame(() => btnRef.current?.focus?.());
  }, []);

  const openLauncher = useCallback(() => setOpen((v) => !v), []);

  const onNavigate = useCallback(
    (app) => {
      navigate(app.path);
      close();
    },
    [navigate, close],
  );

  return (
    <Box position="relative">
      <Tooltip label="Open tools" placement="bottom" hasArrow openDelay={400}>
        <AppLauncherButton
          ref={btnRef}
          isOpen={open}
          onToggle={openLauncher}
          muted={focusLoungeNav && !open}
        />
      </Tooltip>
      <AppLauncherPanel
        isOpen={open}
        onClose={close}
        anchorRef={btnRef}
        favoriteApps={favoriteApps}
        ids={ids}
        streamPlayerUnlocked={streamPlayerUnlocked}
        favoriteIdSet={favoriteIdSet}
        isFull={isFull}
        onReorder={reorder}
        onNavigate={onNavigate}
        removeFromFavorite={removeFromFavorite}
        addToFavorite={addToFavorite}
      />
    </Box>
  );
};

export default AppLauncher;
